module.exports = __webpack_public_path__ + "img/0xa2B726B1145A4773F68593CF171187d8EBe4d495.1ef5074b.png";